import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
export function Stage({ children, ...props }) {
    return (_jsx(StageRoot, { ...props, children: _jsx(StageInner, { children: children }) }));
}
const StageInner = styled.div `
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 0;
`;
const StageRoot = styled.div `
    align-items: center;
    background-color: none;
    border-radius: 0;
    display: flex;
    height: calc(
        100% - var(--Stage_PaddingTop, 1.5rem) -
            var(--Stage_PaddingBottom, 1.5rem)
    );
    justify-content: center;
    left: var(--Stage_PaddingLeft, 1.5rem);
    overflow: hidden;
    position: absolute;
    top: var(--Stage_PaddingTop, 1.5rem);
    width: calc(
        100% - var(--Stage_PaddingLeft, 1.5rem) -
            var(--Stage_PaddingRight, 1.5rem)
    );

    @media (min-width: 60rem) {
        width: calc(
            100% - var(--Stage_PaddingLeft, 1.5rem) -
                var(--Stage_PaddingRight, 1.5rem) +
                var(--Stage_WidthOffset, 0rem)
        );
    }
`;
export const StageContainer = styled.div `
    --Stage_PaddingTop: 0px;
    --Stage_PaddingBottom: 0px;

    height: 100%;
    position: relative;
`;
